import { useLocalSearchParams } from 'expo-router';
import { questionModuleQuery, useModule } from 'system/structure-modules';
import { ParamProvider } from 'util/params';

type ComposerSearchParams = {
    commentKey1: string;
    preselectedPerspectiveText1: string;
    sliderValue1: string;
    voteKey1: string;
    voteLabel1: string;
};

export default function SpaceComposerScreen() {
    const { commentKey1, preselectedPerspectiveText1, sliderValue1, voteKey1, voteLabel1 } = useLocalSearchParams<
        '/[siloKey]/question/[instanceKey]/composer',
        ComposerSearchParams
    >();
    const { QuestionComposerScreen } = useModule(questionModuleQuery);
    return (
        <ParamProvider
            screenParams={{
                commentKey: commentKey1,
                preselectedPerspectiveText: preselectedPerspectiveText1,
                sliderValue: sliderValue1,
                voteKey: voteKey1,
                voteLabel: voteLabel1,
            }}
        >
            <QuestionComposerScreen commentKey={commentKey1} />
        </ParamProvider>
    );
}
